// extracted by mini-css-extract-plugin
module.exports = {"root":"_689690","divider":"_3f454c"};